import Vue from 'vue'
import App from './App.vue'

import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router'
import VueI18n from 'vue-i18n'
import { mapGetters } from 'vuex'
import axios from 'axios'

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if( error.response.status === 401 ){
    store.dispatch('checkUserHash')
  }
  return Promise.reject(error);
});

const $ = require('jquery')
require('bootstrap')

import 'bootstrap/dist/css/bootstrap.min.css'

import './assets/css/font-awesome.min.css'
import './assets/css/elements.css'
import './assets/css/style.css'

import './assets/js/debounce.js'

/* import './assets/plugins/revolution/js/jquery.themepunch.tools.min.js'
import './assets/plugins/revolution/js/jquery.themepunch.revolution.min.js'
import './assets/plugins/revolution/js/revslider.js' */

import 'owl.carousel/dist/assets/owl.carousel.css'
//import 'owl.carousel/dist/assets/owl.theme.default.min.css'
import './assets/css/owl.theme.css'
//import 'owl.carousel'
import 'owl.carousel/dist/owl.carousel.min.js'

/*
import './assets/plugins/cookies/cookiecuttr.css'
import './assets/plugins/cookies/jquery.cookie.js'
import './assets/plugins/cookies/jquery.cookiecuttr.js'
import './assets/plugins/cookies/cookies.js'
*/

/* import './assets/plugins/cookieconsent/cookieconsent.js'
import './assets/plugins/cookieconsent/cookieconsent-init.js'
import './assets/plugins/cookieconsent/cookieconsent.css' */

import './assets/js/plugins.js'
import './assets/js/jquery.isotope.js'
import './assets/js/main.js'

import './assets/plugins/circle/circle.css'
import './assets/css/custom.css'
import './assets/css/custom-productos.css?v0.4'


Vue.use(VueI18n);

const unsync = sync(store, router)

const i18n = new VueI18n({
  locale: 'es',
  //silentTranslationWarn: true
  //silentTranslationWarn: process.env.NODE_ENV === 'production'
});

Vue.mixin({
  methods: {
    toCurrency: (value) => { 
      value = parseFloat(value).toFixed(2) // always two decimal digits
      value = value.replace(".", ",") // replace decimal point character with ,
      value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €" // use . as a separator
      return value;
      //parseFloat(value).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }) 
    },
  }
})

window.addEventListener('beforeunload', (event) => {
  // Cancel the event as stated by the standard.
  //event.preventDefault();
  // Older browsers supported custom message
  //event.returnValue = '';
  sessionStorage.reload = true
});

var app = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  axios,
  created(){
    router.app.$store.dispatch('getUserHash', 'es')
  },
  computed: { ...mapGetters(['getLocale']) },
  watch: {
    '$route' (to, from){
      this.$i18n.locale = this.getLocale
      document.documentElement.setAttribute("lang", this.getLocale.toUpperCase());
      //console.log('Lang: ' + this.getLocale)
    }
  },
  render: h => h(App)
})

i18n.locale = store.getters.getLocale